/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiTransactionSummaryByMonth
 */
export interface ApiTransactionSummaryByMonth {
    /**
     * 
     * @type {number}
     * @memberof ApiTransactionSummaryByMonth
     */
    totalAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof ApiTransactionSummaryByMonth
     */
    startOfMonth?: Date;
}

/**
 * Check if a given object implements the ApiTransactionSummaryByMonth interface.
 */
export function instanceOfApiTransactionSummaryByMonth(value: object): value is ApiTransactionSummaryByMonth {
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    return true;
}

export function ApiTransactionSummaryByMonthFromJSON(json: any): ApiTransactionSummaryByMonth {
    return ApiTransactionSummaryByMonthFromJSONTyped(json, false);
}

export function ApiTransactionSummaryByMonthFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiTransactionSummaryByMonth {
    if (json == null) {
        return json;
    }
    return {
        
        'totalAmount': json['totalAmount'],
        'startOfMonth': json['startOfMonth'] == null ? undefined : (new Date(json['startOfMonth'])),
    };
}

export function ApiTransactionSummaryByMonthToJSON(json: any): ApiTransactionSummaryByMonth {
    return ApiTransactionSummaryByMonthToJSONTyped(json, false);
}

export function ApiTransactionSummaryByMonthToJSONTyped(value?: ApiTransactionSummaryByMonth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalAmount': value['totalAmount'],
        'startOfMonth': value['startOfMonth'] == null ? value['startOfMonth'] : value['startOfMonth'].toISOString().substring(0,10),
    };
}

